import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';


import { pink, purple } from '@mui/material/colors';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import moment from 'moment';
import { ResponsiveContainer} from 'recharts';
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from 'react-leaflet';
import L, { LatLngBoundsExpression } from 'leaflet';
//import 'leaflet/dist/leaflet.css';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import greenicon from 'leaflet/dist/images/leaf-green.png';
import greenshadow from 'leaflet/dist/images/leaf-shadow.png';

import redicon from 'leaflet/dist/images/leaf-green.png';
import redshadow from 'leaflet/dist/images/leaf-shadow.png';

import PageBase from '../site/PageBase';
//import LiveMap from './LiveMap';
import {apipost, apiraw, bizpost} from '../../ajax';
import { LatLngExpression } from 'leaflet';
import metericon from '../icons/meter.png';
import apply from '../icons/receipt.svg';
import pay from '../icons/pay-per-click.svg';
import submit from '../icons/submit.svg';
import process from '../icons/thinking.svg';
import complete from '../icons/task-complete.svg';

import {blueIcon,goldIcon,redIcon,greenIcon,orangeIcon} from '../icons';
import {yellowIcon,violetIcon,greyIcon,blackIcon} from '../icons';
import BadgeMarker, { AnimatedBadgeMarker } from '../maps';
import { Box } from '@mui/material';


const s:any = {
  maproot: {
    flexGrow: 1,
    flexShrink: 1,
  },
  // mapboardpaper: {
  //   backgroundColor: 'white',
  //   //maxHeight: 600,
  //   height: '100%',
  //   // height: 150
  //   marginLeft: 10,
  //   marginRight: 10,
  // },
  mapdiv: {
    // height: 95,
    //padding: '5px 15px 0 15px'
  },
  mapheader: {
    fontSize: 24,
    fontWeight: 'typography.fontWeightLight',
    color: 'white',
    backgroundColor: purple['600'],
    padding: 10,
  },
  paper: {
    backgroundColor: 'white',
    minHeight: 800,
    // overFlow: 'hidden'
    height: '100%',
    marginTop: 10,
  },
  div: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '95%',
    //height: 300,
  },
  header: {
    color: 'white',
    backgroundColor: pink['600'],
    padding: 1,
    fontSize: 24,
    fontWeight: 300,
  },
  custom_tooltip:{
    lineHeight: 0.2,
    backgroundColor: 'white',
    padding: 5
  },
  nodata: {
    display: 'flex',
    justifyContent: 'center'
  },
  barchart:{
    marginTop: 20
  }
};

const ntrmsicons:any = {
  REQUEST:L.icon({iconUrl:apply,shadowUrl:iconShadow}),
  PAYMENT:L.icon({iconUrl:pay,shadowUrl:iconShadow}),
  SUBMISSION:L.icon({iconUrl:submit,shadowUrl:iconShadow}),
  PROCESSING:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  SUBTASK:L.icon({iconUrl:process,shadowUrl:iconShadow}),
  COMPLETE:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
  DELIVERY:L.icon({iconUrl:complete,shadowUrl:iconShadow}),
}

const ntrmsicon = L.icon({iconUrl:process,shadowUrl:iconShadow});

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;



/*

var myIcon= L.Icon.extend({
        options: {
            iconUrl: 'icon.png',
            iconSize: [7.5, 7.5],
            iconAnchor: [0, 0]
        }
    });

var ic = new myIcon({iconSize: [7.5, 7.5]});
    var marker = L.marker([-15.7745457, -48.3575684], {icon: ic}).addTo(map);

map.on('zoomend', function() {
var actualZoom = map.getZoom();
var newSize = 60/((20 - actualZoom )*2);

var resizedIcon = new myIcon({iconSize: [newSize ,newSize ]});      
marker.setIcon(resizedIcon );
});

*/

class EventMap extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  map:any;
  constructor(props:any) {
    super(props);

    this.map = createRef();

    const {mapper={}} = this.props;
    const {cc=[5.64046614, -0.2921927]} = mapper;
    const {bb=[[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]]} = mapper;
    const mcenter:LatLngExpression = cc; //||[8.977850, 39.253099];
    const mpos:LatLngExpression = cc; //||[9.01055, 38.74750];
    const mtext = `NTRMS Event. <br /> Event Location.`;
    const mbounds:LatLngBoundsExpression = bb;
    const mzoom = 13;
    const mtitle = 'Event Map';
    
    const {title=mtitle,mapcenter=mcenter,mapbounds=mbounds,mapzoom=mzoom,mappos=mpos,maptext=mtext,markerpos=mpos,markertext=mtext} = props;

    this.state = {
      count: 0,
      mtitle:title,
      mcenter:mapcenter,
      mbounds:mapbounds,
      mzoom:mapzoom,
      mpos:mappos,
      mtext:maptext,
      mkpos:markerpos,
      mktet:markertext,
      maplayer: null,
    };
  }

  componentDidMount(): void {
      const cmap = this.map.current;
      console.log('map',cmap);
      this.baseload();
  }


  mapload = async(file:string) => {
    try{
      const baseparams = {file};
      const response = await apiraw('/api/resource/maps','',baseparams);
      return response; //TODO: return file
    }
    catch(error){
      console.log('mapload error',error);
      return Promise.reject(error);
    } 
  //TODO: call LoadMarkers
  
  }

  baseload = async() => {
    try{
      const rs = await this.mapload('ghana_regions.json');
      console.log('baselayer',rs);
      this.setState({maplayer:rs});
    }
    catch(error){
      console.log('baseload error',error);
      return Promise.reject(error);
    } 
  }

  placesload = async() => {
    try{
      return await this.mapload('ghana-towns.json');
    }
    catch(error){
      console.log('placesload error',error);
      return Promise.reject(error);
    } 
  }

  merge = (p:string, ...arrs:any[]) => [].concat(...arrs).reduce((a, b) => !a.filter(c => b[p] === c[p]).length ? [...a, b] : a, []);


  render() {
    const {classes} = this.props;
    const {mtitle,mcenter,mbounds,mzoom,mpos,mtext,mkpos,mktext} = this.state;
    const {maplayer} = this.state;
    const {title=mtitle,recordset=[],mapcenter=mcenter,mapbounds=mbounds} = this.props;

    const {mapzoom=mzoom,mappos=mpos,maptext=mtext,markerpos=mkpos} = this.props;

    const {markertext=mktext} = this.props;

    console.log('maplayer',maplayer);

    // For full Ghana map, use the following
    //const bounds:LatLngBoundsExpression = [[4.873673,-3.397779],[11.180002,1.381273]];
    //const center:LatLngExpression = [8.34046614, -0.4921927];
    //const pos:LatLngExpression = [5.95446614, -0.2921927];
    //const zoom = 7;

    // For zoomed into Accra metropolis, use the following
    // const pos:LatLngExpression = [5.95446614, -0.2921927];
    // const bounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    // const center:LatLngExpression = [5.64046614, -0.2921927];
    // const zoom = 13;

    // For zoomed into Accra metropolis, use the following
    const npos:LatLngExpression = [5.54959014, -0.1964927]; //default
    const gpos:LatLngExpression = [5.57059614, -0.1924027]; //green
    const fpos:LatLngExpression = [5.62590614, -0.1801927]; //gold
    const bpos:LatLngExpression = [5.66296614, -0.1534027]; //red
    const bounds:LatLngBoundsExpression = [[5.01046214438, -3.24437008301],[11.3983409693, 1.0601216976]];
    const center:LatLngExpression = [5.60046614, -0.1821927];
    const zoom = 12;

    //
    //const bounds:LatLngBoundsExpression = [[4.71046214438, -3.24437008301],[11.0983409693, 1.0601216976]];
    //const boundx:LatLngBoundsExpression = [[-3.318,11.265],[1.406,4.489]];
    //const bounds:LatLngBoundsExpression = [[4.489,-3.318],[11.265,1.406]];
    //const bounds:LatLngBoundsExpression = [[4.873673,-3.397779],[11.180002,1.381273]];
    //const center:LatLngExpression = [8.34046614, -0.4921927];
    //const center = bounds.getCenter();

    return (
      <Paper sx={{...s.paper}}>
        <Box sx={{...s.header}}>{title}</Box>
        <Box sx={{...s.div}}>
          <ResponsiveContainer >
            <MapContainer 
              ref={this.map} 
              center={center} 
              zoom={zoom} 
              scrollWheelZoom={false} 
              style={{height:'100vh',width:'100%'}} 
              bounds={bounds}>
              <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" bounds={bounds}
              />
              <GeoJSON attribution="&copy; credits due..." data={maplayer} />
              {/* <BadgeMarker
                position={[5.6037, -0.1870]}
                badgeValue={12}
                badgeColor="purple"
                onClick={() => alert("Marker clicked!")}
              /> */}
              {/* <BadgeMarker
                position={[5.6, -0.18]}
                value="99+"
                sx={{ fontWeight: "bold", backgroundColor: "#673ab7" }}
                animate={true}
              /> */}
              <AnimatedBadgeMarker
                position={[5.6, -0.18]}
                value={7}
                badgeColor="#651fff"
                textColor="#fff"
                sx={{ fontWeight: "bold" }}
              />
              <Marker position={npos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              <Marker position={bpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              <Marker position={fpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              <Marker position={gpos} icon={greyIcon}>
                <Popup>
                  {maptext}
                </Popup>
              </Marker>
              {recordset.map((record:any, idx:number) => 
                <Marker key={record.rid} position={record.geo} icon={ntrmsicons[record.evc]}>
                <Popup>
                  <Box component='span'>TRACK:{record.tri}<br/>REF:{record.rfn}<br/>MDA:{record.enc}<br/>EVENT: {record.evc}<br/>ACTIVITY: {record.acc}<br/>STATUS: {record.vsc}<br/>DATE: {record.dcd}</Box>
                </Popup>
              </Marker>
              )}
            </MapContainer>
          </ResponsiveContainer>
        </Box>
      </Paper>
    );
  }
}

EventMap.propTypes = {
  data: PropTypes.array
};

export default EventMap;



/*
  /////////////////// OTHER METHODS  ////////////////////////


  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }


  //////////////////////////////map//////////////////////////////
  mapload = async(filename:string) => {
    try{
      const baseparams = {filename}; //,sta:date
      const response = await apipost('/api/resource/map','',baseparams);
      //this.setState({markers:response.sd});
      //this.map.addLayer(this.liveLayer);
      //this.liveLayer.clearLayers();
      //this.loadMakersLeaflet();
      return response; //TODO: return file
    }
    catch(error){
      console.log('map.bizpost error',error);
      return Promise.reject(error);
    } 
    //TODO: call LoadMarkers
    
  }

  baseload = async() => {
    try{
      return await this.mapload('ghana-regions.json');
    }
    catch(error){
      console.log('baseload error',error);
      return Promise.reject(error);
    } 
  }

  placesload = async() => {
    try{
      return await this.mapload('ghana-towns.json');
    }
    catch(error){
      console.log('placesload error',error);
      return Promise.reject(error);
    } 
  }



    liveLoad = async(code:any,date:any) => {
      try{
        const {recordset:previousset,lastread} = this.state;
        const {eni} = this.props;
        //const start = moment.format()
        const baseparams = {s:'marker',a:'find',eni,stp:lastread};
        const response = await bizpost(baseparams);
        const {sd:currentset} = response;
        const recordset = this.merge('rid',previousset,currentset);
        this.setState({recordset,previousset,currentset});
        //this.map.addLayer(this.liveLayer);
        //this.liveLayer.clearLayers();
  
        //this.loadMakersLeaflet();
      }
      catch(error){
        console.log('map.bizpost error',error);
      } 
      //TODO: call LoadMarkers
      
    }
  
    ttFormatTime = (stamp:any) => {
      return moment.unix(stamp).format('DD MMM');
    }
  
    /////////////////  ACCESSING THE MAP VANILLA JS/HTML////////////////////////
    var map = L.map('map').setView([55.4411764, 11.7928708], 13);

    L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);

    // quick and dirty: create a big icon
    L.Icon.Big = L.Icon.Default.extend({
        options: {
        iconSize: new L.Point(45, 81),
    }});

    var bigIcon = new L.Icon.Big();
    var centerPoint = L.latLng(55.4411764, 11.7928708);
    var centerMarker = L.marker(centerPoint, { title: 'unselected' });
    centerMarker.addTo(map);

    centerMarker.on('click', function(e) {
        centerMarker.setIcon(bigIcon);
    });
    */